import Dropdown from 'flarum/common/components/Dropdown';
import ItemList from 'flarum/common/utils/ItemList';
import icon from 'flarum/common/helpers/icon';
import classList from 'flarum/common/utils/classList';

export default class IconSelectorComponent extends Dropdown {
  static initAttrs(attrs) {
    super.initAttrs(attrs);

    attrs.className = 'icondropdown';
    attrs.buttonClassName = 'Button Button--icon';
    attrs.menuClassName = 'social-dropdown-menu';
  }

  oninit(vnode) {
    super.oninit(vnode);

    this.icons = {
      social: [
        'fas fa-envelope',
        'fas fa-globe',
        'fas customized fa-lofter',
        'fas customized fa-sina',
        'fas customized fa-qq',
        'fas customized fa-wechat',
        'fas customized fa-genshin',
        'fas customized fa-arknights',
        'fas customized fa-twitter',
        'fas customized fa-poipiku',
        'fas customized fa-privatter',
        'fas customized fa-pixiv',
      ],
    };
  }

  view(vnode) {
    vnode.children = this.items().toArray();

    return super.view(vnode);
  }

  getButtonContent() {
    const ic = (str) => icon(str, { className: 'icondropdown-activeIcon fa-fw' });

    return [
      /^favicon(-\w+)?$/.test(this.attrs.selection())
        ? this.attrs.allowsExternal
          ? [
              <img
                className={classList({
                  'icondropdown-activeIcon': true,
                  'social-greyscale-button': this.attrs.selection() === 'favicon-grey',
                  'social-button': !this.attrs.selection() === 'favicon-grey',
                })}
                alt=""
                src={this.attrs.favicon()}
                onerror={() => {
                  this.attrs.favicon('none');
                  this.select(this.icons.social[0]);
                }}
              />,
            ]
          : ic('fas fa-globe')
        : ic(this.attrs.selection()),
      this.attrs.caretIcon ? icon(this.attrs.caretIcon, { className: 'Button-caret' }) : '',
    ];
  }

  items() {
    const items = new ItemList();



    this.icons.social.forEach((curIcon) => {
      items.add(
        curIcon.replace(/ /, '-'),
        <div
          onclick={() => this.select(curIcon)}
          className={classList({ 'iconpicker-item': true, 'iconpicker-item--highlighted': this.attrs.selection() === curIcon })}
          role="button"
          title={`.${curIcon}`}
        >
          {icon(curIcon, { className: 'social-icon fa-fw' })}
        </div>,
        100
      );
    });

    return items;
  }

  select(icon) {
    this.attrs.selection(icon);
  }
}
